import { render } from "./EditSalaryOtherComponent.vue?vue&type=template&id=ff5cf1fe&scoped=true"
import script from "./EditSalaryOtherComponent.vue?vue&type=script&lang=js"
export * from "./EditSalaryOtherComponent.vue?vue&type=script&lang=js"

import "./EditSalaryOtherComponent.vue?vue&type=style&index=0&id=ff5cf1fe&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff5cf1fe"]])

export default __exports__